import { useAppSelector } from "@/hooks/useAppSelector";
import { ChartContainer, ChartTooltip } from "@/components/ui/chart";
import { BarChart, Bar, XAxis, YAxis } from "recharts";

export const CompaniesEmployeeGraph = () => {
  const { companies } = useAppSelector(state => state.supaCompanies);

  // Process companies data to count employees by category
  const employeeData = companies.reduce((acc: { [key: string]: number }, company) => {
    const employeeCount = company.employees;
    if (employeeCount && employeeCount !== 'Unknown') {
      acc[employeeCount] = (acc[employeeCount] || 0) + 1;
    }
    return acc;
  }, {});

  // Convert to array format for Recharts
  const chartData = Object.entries(employeeData).map(([range, count]) => ({
    range,
    count,
  }));

  // Custom sort order for employee ranges (largest to smallest)
  const getRangeValue = (range: string): number => {
    if (range === '10000+') return Number.MAX_SAFE_INTEGER; // Ensures 10000+ always comes first
    const match = range.match(/(\d+)-?(\d+)?/);
    if (match) {
      return parseInt(match[2] || match[1]);
    }
    return 0;
  };

  // Sort data by employee range (largest to smallest)
  chartData.sort((a, b) => getRangeValue(b.range) - getRangeValue(a.range));

  return (
    <div className="w-full bg-white p-6 rounded-lg shadow-sm">
      <h3 className="text-lg font-semibold mb-4 text-black">Company Size Distribution</h3>
      <div className="flex flex-col items-start w-full">
        <div className="w-full h-[400px]">
          <ChartContainer
            config={{
              bar: {
                theme: {
                  light: "#4285f4",
                  dark: "#4285f4",
                },
              },
            }}
          >
            <BarChart 
              data={chartData} 
              margin={{ top: 20, right: 30, left: 30, bottom: 60 }}
              width={800}
              height={400}
            >
              <XAxis
                dataKey="range"
                angle={-45}
                textAnchor="end"
                height={80}
                tick={{ fill: '#000000', fontSize: 12 }}
                stroke="#000000"
              />
              <YAxis
                tick={{ fill: '#000000', fontSize: 12 }}
                stroke="#000000"
                label={{ 
                  value: 'Number of Companies', 
                  angle: -90, 
                  position: 'insideLeft', 
                  fill: '#000000'
                }}
              />
              <Bar 
                dataKey="count" 
                fill="#4285f4"
                radius={[4, 4, 0, 0]} 
              />
              <ChartTooltip />
            </BarChart>
          </ChartContainer>
        </div>
      </div>
    </div>
  );
};